export default "__VITE_ASSET__DTGRd$UE__"